export default __webpack_public_path__ + "static/media/checkbox-full-disabled.icon.a70ac3c6.svg";